module.exports = __webpack_public_path__ + "img/arrow-black.fc3c19bf.svg";